import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBullseye,
  faEye,
  faHandsHelping,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState, useRef } from "react";

export const About = () => {
  const sectionRefs = useRef({
    titleSection: null,
    flexSection1: null,
    fullTextSection: null,
    flexSection2: null,
    missionVisionValues: null,
  });

  const [visibleSections, setVisibleSections] = useState({
    titleSection: false,
    flexSection1: false,
    fullTextSection: false,
    flexSection2: false,
    missionVisionValues: false,
  });

  useEffect(() => {
    const options = {
      threshold: 0.14,
    };

    const observers = Object.entries(sectionRefs.current).map(([key, el]) => {
      if (!el) return null;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => ({
              ...prev,
              [key]: true,
            }));
            observer.unobserve(entry.target);
          }
        });
      }, options);
      observer.observe(el);
      return observer;
    }).filter(Boolean);

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, []);

  const getSectionStyle = (visible) => ({
    opacity: visible ? 1 : 0,
    transform: visible ? "translateY(0)" : "translateY(30px)",
    transition: "opacity 0.8s ease, transform 0.8s ease",
  });

  return (
    <>
      <section
        id="about"
        style={{
          fontFamily: "'Segoe UI', sans-serif",
          backgroundColor: "#f9fafb",
          color: "#4b5563",
          paddingBottom: 0,
        }}
      >
        <div
          ref={(el) => (sectionRefs.current.titleSection = el)}
          style={{
            ...getSectionStyle(visibleSections.titleSection),
            background: "linear-gradient(to right, #3F4E4F, #3F4E4F)",
            width: "100%",
          }}
        >
          <div
            style={{
              maxWidth: 1000,
              margin: "0 auto",
              padding: "30px 20px",
            }}
          >
            <h2
              style={{
                fontSize: "2rem",
                color: "#DCD7C9",
                marginBottom: 0,
                marginTop: 10,
                fontWeight: "bold",
                textAlign: "center",
                lineHeight: 1.4,
              }}
            >
              Your Trusted Partner in Food Production, Infrastructure Development & International Markets
            </h2>
          </div>
        </div>

        <div
          ref={(el) => (sectionRefs.current.flexSection1 = el)}
          style={{
            ...getSectionStyle(visibleSections.flexSection1),
            maxWidth: 1000,
            margin: "0 auto",
            padding: "40px 20px 0 20px",
          }}
        >
          <div style={{ textAlign: "start", marginBottom: 24 }}>
            <h1
              style={{
                fontSize: "4rem",
                background: "linear-gradient(to right,rgb(202, 150, 78), #C38745)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                borderBottom: "3px solid #C38745",
                display: "inline-block",
                paddingBottom: 10,
                fontWeight: "bold",
                margin: 0,
              }}
            >
              About Us
            </h1>
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 24,
              marginBottom: 32,
              alignItems: "center",
            }}
          >
            <div
              style={{
                flex: "1 1 60%",
                minWidth: 280,
                fontSize: "1.25rem",
                lineHeight: 1.7,
              }}
            >
              At Tahil Group, we currently produce flour locally and source pasta,
              confectionery products, and canola oil internationally according to demand.
              Our future goal is to build new factories in less populated areas of Alberta
              to manufacture these products locally, supporting rural development and
              creating new employment opportunities.
              <br />
              <br />
              With our production facility and dedicated sales office in Alberta, we proudly
              supply fresh, nutritious, and consistently reliable products to families,
              bakeries, food manufacturers, and private label partners across Canada.
              <br />
              <br />
              As more consumers and health professionals emphasize the importance of natural,
              additive-free food, Tahil Group is committed to delivering wholesome, grain-based
              products that meet this growing demand for healthy eating — always natural and
              free from unnecessary chemicals and additives.
              Our diverse product offering serves a wide range of customers, from local grocery
              retailers to large-scale bakeries and food processors throughout Alberta and
              the rest of Canada. Thanks to our strategic location, we carefully source
              high-quality raw materials worldwide while ensuring fast and dependable distribution.
            </div>

            <div
              style={{
                flex: "1 1 10%",
                minWidth: 280,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <img
                src="/img/1111.png"
                alt="Tahil Group Factory"
                loading="lazy"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                }}
              />
            </div>
          </div>

          <div
            ref={(el) => (sectionRefs.current.fullTextSection = el)}
            style={{
              ...getSectionStyle(visibleSections.fullTextSection),
              fontSize: "1.25rem",
              lineHeight: 1.7,
              marginBottom: 10,
              maxWidth: 1000,
              margin: "0 auto",
              padding: "0 20px",
            }}
          >
            Our vision goes far beyond production alone. We invest in revitalizing underused
            farmlands, modernizing aging rural infrastructure, and strengthening local economies
            through long-term initiatives. With these efforts, we aim to create over 550 new jobs
            and make a lasting, positive impact on community growth and prosperity in Alberta.
            <br />
            <br />
            Led by a team of experienced industry experts and skilled professionals, we operate
            according to the highest international standards of quality, food safety, and hygiene.
            We support continuous development for our employees and embrace innovative production
            and sustainable agriculture practices to maintain our strong position in Canada’s food industry.
          </div>

          <div
            ref={(el) => (sectionRefs.current.flexSection2 = el)}
            style={{
              ...getSectionStyle(visibleSections.flexSection2),
              display: "flex",
              flexWrap: "wrap",
              gap: 24,
              alignItems: "center",
              maxWidth: 1000,
              margin: "0 auto",
              padding: "0 20px 40px 20px",
            }}
          >
            <div
              style={{
                flex: "1 1 10%",
                minWidth: 280,
                paddingBottom: 0,
              }}
            >
              <img
                src="/img/2222.png"
                alt="Tahil Group Factory"
                loading="lazy"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                }}
              />
            </div>

            <div
              style={{
                flex: "1 1 60%",
                minWidth: 280,
                fontSize: "1.5rem",
                lineHeight: 1.7,
              }}
            >
              <div style={{ textAlign: "end", marginBottom: 24 }}>
                <h1
                  style={{
                    fontSize: "4rem",
                    background: "linear-gradient(to right,rgb(202, 150, 78), #C38745)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    borderBottom: "3px solid #C38745",
                    display: "inline-block",
                    paddingBottom: 10,
                    fontWeight: "bold",
                    margin: 0,
                  }}
                >
                  Who We Are
                </h1>
              </div>
              Tahil Group is more than a producer — we are a forward-thinking, community-focused partner dedicated to unlocking the full potential of Alberta’s rural regions. Our team brings together experienced engineers, dedicated farmers, and passionate professionals who work every day to bring better, healthier products to market and help build stronger, more resilient communities.
              We believe that sustainable growth and responsible development go hand in hand. Every project we pursue is designed to support local prosperity, promote modern agriculture, and secure a better future for generations to come.
            </div>
          </div>
        </div>
      </section>

      <section
        ref={(el) => (sectionRefs.current.missionVisionValues = el)}
        style={{
          ...getSectionStyle(visibleSections.missionVisionValues),
          padding: "40px 5%",
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{
            maxWidth: "1400px",
            margin: "0 auto",
            backgroundColor: "#ffffff",
            padding: "40px 30px",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
            marginBottom: '50px',
          }}
        >
          {[{
            icon: faBullseye,
            title: "Mission",
            text: "To create long-term economic value by turning Canadian agricultural resources into high-quality products, revitalizing rural infrastructure, and driving job creation through strategic cross-sector investments.",
          }, {
            icon: faEye,
            title: "Vision",
            text: "To become a leader in unlocking the economic potential of rural Canada through sustainable value-added production and strategic development.",
          }, {
            icon: faHandsHelping,
            title: "Core Values",
            text: "Integrity. Sustainability. Community. Innovation. Impact.",
          }].map((item, index) => (
            <div
              key={index}
              style={{
                flex: "1 1 300px",
                padding: "10px 20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 12,
                borderLeft: index !== 0 ? "1px solid #e5e7eb" : "none",
              }}
            >
              <FontAwesomeIcon icon={item.icon} size="2x" color="#C38745" />
              <h3
                style={{
                  fontSize: "2rem",
                  color: "#C38745",
                  fontWeight: "bold",
                  margin: 0,
                }}
              >
                {item.title}
              </h3>
              <p style={{ fontSize: "1.4rem", lineHeight: 1.6 }}>{item.text}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};
